module.exports = __webpack_public_path__ + "img/stock5.210bf045.png";